import React, { Component } from "react";
import RadioCheck from "../../../utils/components/RadioCheck";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import { setAlert } from "../../../../actions/alertActions";
import arrow_icon from "../../../../styles/images/arrow-breadcrumb.svg";

export class FormPlatformPermissions extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      api: false,
      webclient: false,
      mobile: false,
    };
  }

  componentDidMount() {
    if (this.props.isEditing) {
      const { userInfo } = this.props;
      this.setState({
        api: userInfo.accessPlatform.api,
        webclient: userInfo.accessPlatform.webclient,
        mobile: userInfo.accessPlatform.mobile,
      });
    }
  }

  prevStep = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  onChangePlatform = (value) => (e) => {
    if (value === "api") {
      this.setState({ api: !this.state.api });
    } else if (value === "webclient") {
      this.setState({ webclient: !this.state.webclient });
    } else if (value === "mobile") {
      this.setState({ mobile: !this.state.mobile });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { ownerId, values } = this.props;
    const platformPermissions = {
      api: this.state.api,
      webclient: this.state.webclient,
      mobile: this.state.mobile,
    };

    const guestUser = Object.assign(values, platformPermissions);

    if (this.props.isEditing) {
      this.props.editGuestUser(guestUser, ownerId);
    } else {
      this.props.addGuestUser(guestUser, ownerId);
    }
  };

  render() {
    return (
      <div
        id="access-management-platform"
        className="main-component main-container access-management-add"
      >
        <div className="component-container">
          <div className="row">
            <div className="col-sm-12 d-flex">
              <h6 className="disable-text">
                {I18n.t("accessManagement_title")}
                <img src={arrow_icon} alt="Icon arrow" />
                {I18n.t("drivers_addUser")}
                <img src={arrow_icon} alt="Icon arrow" />
              </h6>
              <h6 className="d-flex align-items-center">
                {I18n.t("accessManagement_platformPermission")}
              </h6>
            </div>
          </div>
          <b className="mt-3">{I18n.t("accessManagement_platformAccess")}</b>
          <div className="form-field form-platform">
            <RadioCheck
              label="API"
              labelPos="right"
              name="api"
              value={this.state.api}
              checked={this.state.api === true}
              onChange={this.onChangePlatform("api")}
              disabled={this.props.isAdmin ? false : true}
            />
            <RadioCheck
              label="Webclient"
              labelPos="right"
              name="webclient"
              value={this.state.webclient}
              checked={this.state.webclient === true}
              onChange={this.onChangePlatform("webclient")}
            />
            <RadioCheck
              label={I18n.t("accessManagement_mobileAccess")}
              labelPos="right"
              name="mobile"
              value={this.state.mobile}
              checked={this.state.mobile === true}
              onChange={this.onChangePlatform("mobile")}
            />
          </div>

          <div className="guest-user-prev-next">
            <button
              className="button-prev-next"
              type="button"
              form="add-guest-users-form"
              onClick={this.prevStep}
            >
              {I18n.t("pageArrowButton_left")}
            </button>
            <button
              className="button-submit"
              type="submit"
              onClick={this.handleSubmit}
            >
              {I18n.t("backOffice_network_forms_submit_bt")}
            </button>
          </div>

          <div className="dots-section">
            <span className="dot-progress dot-background"></span>
            <span className="dot-progress dot-background"></span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(FormPlatformPermissions);
